import { $t } from '../../i18n'
import { BaseAPIError } from './BaseAPIError'

export class UnhandledAPIError extends BaseAPIError {
  constructor(options?: ErrorOptions) {
    super($t('An unexpected error has occurred.'), options)
  }
}
